import { createContext, useContext, useEffect, useRef, useState } from "react";

import { useARC } from "./ARCProvider";

import { ConnectionState } from "lib/consts/ARC/connection";
import { DefaultShowIAQ } from "lib/consts/ARC/IAQ";

export const IAQContext = createContext();
IAQContext.displayName = "ARCIAQ";
export const useIAQ = () => useContext(IAQContext);

const IAQProvider = ({ children }) => {
    const { connectionState } = useARC();

    const [showIAQ, setShowIAQ] = useState(DefaultShowIAQ);

    const lastConnectionState = useRef(connectionState);
    const lastShowIAQ = useRef(showIAQ);

    useEffect(() => {
        if (lastConnectionState !== connectionState) setShowIAQ(lastShowIAQ.current);

        lastShowIAQ.current = showIAQ;
        lastConnectionState.current = connectionState;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionState]);

    return <IAQContext.Provider value={{ showIAQ, setShowIAQ }}>{children}</IAQContext.Provider>;
};

export default IAQProvider;
